import React from "react";
import { Box, Typography } from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const AlreadySignedPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: "20px",
        textAlign: "center",
        maxWidth: "600px",
      }}
    >
      <ReportProblemIcon sx={{ fontSize: 60, color: "orange", mb: 2 }} />
      <Typography variant="h3" component="h3" gutterBottom>
        Contract Already Signed
      </Typography>
      <Typography variant="h5" component="p">
        You have already signed.
      </Typography>
    </Box>
  );
};

export default AlreadySignedPage;
